import { render, staticRenderFns } from "./UploadRevision.vue?vue&type=template&id=4b4af150&scoped=true"
import script from "./UploadRevision.vue?vue&type=script&lang=js"
export * from "./UploadRevision.vue?vue&type=script&lang=js"
import style0 from "./UploadRevision.vue?vue&type=style&index=0&id=4b4af150&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4af150",
  null
  
)

export default component.exports